export default class InstitutionsAPI {
  private services: any;

  constructor(services) {
    this.services = services;
  }

  // NEW JULY 2023
  public getCoursesSummary(startDate, endDate) {
    return this.services.plBaseAPI.get(
      `/institutions/courses/summaries/${startDate}/${endDate}`,
      false
    );
  }

  public getCourseEnrolledLearners(courseId, startDate, endDate) {
    return this.services.plBaseAPI.get(
      `institutions/courses/${courseId}/enrolled_learners/${startDate}/${endDate}/list`
    );
  }

  public getSingleCourseSummary(courseId, startDate, endDate) {
    return this.services.plBaseAPI.get(
      `institutions/courses/${courseId}/summary/${startDate}/${endDate}`
    );
  }

  public getLessonSummary(courseId, lessonId, startDate, endDate) {
    return this.services.plBaseAPI.get(
      `institutions/courses/${courseId}/lessons/${lessonId}/${startDate}/${endDate}/summary`
    );
  }
  public getLessonLearners(courseId, lessonId, startDate, endDate) {
    return this.services.plBaseAPI.get(
      `institutions/courses/${courseId}/lessons/${lessonId}/${startDate}/${endDate}/learners`
    );
  }

  public getLearnerGeneralStats(learnerId) {
    return this.services.plBaseAPI.get(
      `institutions/learners/${learnerId}/general_stats`
    );
  }
  // END NEW JULY 2023

  public getCourseDetails({ institutionID, courseID }) {
    return this.services.baseAPI.get(
      `/institutions/course/details?institutionid=${institutionID}&courseid=${courseID}`,
      false
    );
  }
  public getInstitutionsAssessments(institutionID) {
    return this.services.baseAPI.get(
      `institutions/${institutionID}/assessments`
    );
  }

  public getInstitutionsProfile(institutionID) {
    return this.services.baseAPI.get(`institutions/${institutionID}/profile`);
  }

  public getInstitutionsOverallAssessmentStats(institutionID, assessmentID) {
    return this.services.baseAPI.get(
      `institutions/${institutionID}/assessments/${assessmentID}/overall_stats`
    );
  }

  public getInstitutionAssessmentSearchFilters(
    institutionID,
    assessmentID,
    searchQuery
  ) {
    return this.services.baseAPI.get(
      `institutions/${institutionID}/search_filters/assessments/${assessmentID}/?${searchQuery}`
    );
  }
  public getInstitutionAssessmentSearchFiltered(
    institutionID,
    assessmentID,
    searchQuery
  ) {
    return this.services.baseAPI.get(
      `institutions/${institutionID}/search_filters/assessments/${assessmentID}/?${searchQuery}`
    );
  }

  // public getInstitutionAssessmentLevelsBreakdown(institutionID, assessmentID) {
  //   return this.services.baseAPI.get(`institutions/${institutionID}/user_alert_levels_overview/${assessmentID}/`)
  // }
  public getInstitutionAssessmentLevelsBreakdownFiltered(
    institutionID,
    assessmentID,
    cohort,
    searchQuery
  ) {
    return this.services.baseAPI.get(
      `institutions/${institutionID}/user_alert_levels_overview/${cohort}/${assessmentID}/?${searchQuery}`
    );
  }

  public getCohortData(institutionID, assessmentID, searchQuery) {
    return this.services.baseAPI.get(
      `institutions/${institutionID}/user_cohorts_overview/${assessmentID}/?${searchQuery}`
    );
  }

  // public getInstitutionStudentsRiskGroup(institutionID, assessmentID, alertID) {
  //   return this.services.baseAPI.get(`institutions/${institutionID}/filtered_alerts/${alertID}/assessments/${assessmentID}/`)
  // }

  public getInstitutionAssessmentStudentSearchFiltered(
    institutionID,
    searchFilterID,
    assessmentID
  ) {
    return this.services.baseAPI.get(
      `institutions/${institutionID}/search_filters/${searchFilterID}/assessments/${assessmentID}/`
    );
  }

  public genInstitutionAssessmentCSV(
    institutionID,
    cohort,
    assessmentID,
    sid,
    regenerate,
    selectedYearGroup
  ) {
    if (selectedYearGroup) {
      return this.services.plBaseAPI.get(
        `institutions/assessments/${assessmentID}/reports/completion_summary_report/${cohort}?sid=${sid}&regenerate=${regenerate}&yeargroup=${selectedYearGroup}`
      );
    }

    return this.services.plBaseAPI.get(
      `institutions/assessments/${assessmentID}/reports/completion_summary_report/${cohort}?sid=${sid}&regenerate=${regenerate}`
    );
  }

  public genInstitutionAssessmentZip(
    institutionID,
    cohort,
    assessmentID,
    yearGroup,
    sid,
    regenerate
  ) {
    if (yearGroup) {
      return this.services.baseAPI.get(
        `institutions/${institutionID}/${cohort}/genzip/${assessmentID}?sid=${sid}&yeargroup=${yearGroup}&regenerate=${regenerate}`
      );
    }
    return this.services.baseAPI.get(
      `institutions/${institutionID}/${cohort}/genzip/${assessmentID}?sid=${sid}&regenerate=${regenerate}`
    );
  }

  public getSchoolStudents(page, size) {
    return this.services.baseAPI.get(
      `institutions/student_members/?page=${page}&page_size=${size}`,
      false
    );
  }

  public getCohortsList(institutionID, assessmentId) {
    return this.services.baseAPI.get(
      `institutions/${institutionID}/cohorts/${assessmentId}`
    );
  }

  public getInstitutionCohortPerceptions(
    institutionID,
    userType,
    cohortID,
    perceptionsID,
    yearGroup
  ) {
    return this.services.baseAPI.get(
      `institutions/${institutionID}/generic_cohorts/${cohortID}/perceptions/${perceptionsID}/${userType}?year_group=${yearGroup}`
    );
  }
  public getInstitutionCohortPerceptionsFiltered(
    institutionID,
    userType,
    cohortID,
    perceptionsID,
    searchQuery
  ) {
    return this.services.baseAPI.get(
      `institutions/${institutionID}/generic_cohorts/${cohortID}/perceptions/${perceptionsID}/${userType}?${searchQuery}`
    );
  }

  public getSinglePageZip(
    institutionId,
    assessmentId,
    cohort,
    sid,
    regenerate,
    yeargroup
  ) {
    if (yeargroup) {
      return this.services.plBaseAPI.get(
        `institutions/assessments/${assessmentId}/reports/getting_to_know_you_reports/${cohort}?sid=${sid}&regenerate=${regenerate}&yeargroup=${yeargroup}`
      );
    }

    return this.services.plBaseAPI.get(
      `institutions/assessments/${assessmentId}/reports/getting_to_know_you_reports/${cohort}?sid=${sid}&regenerate=${regenerate}`
    );
  }

  public updateInstitutionProfile(item) {
    return this.services.baseAPI.put(`institutions/profiles/update`, item);
  }

  public getTeachersList(institutionID) {
    return this.services.baseAPI.get(
      `institutions/${institutionID}/teacher_list`
    );
  }

  public getUserTypeAssessmentList(institutionID, userType) {
    return this.services.baseAPI.get(
      `institutions/${institutionID}/user_assessments_list/${userType}/`
    );
  }

  public getUsersAlertLevelListData(
    institutionID,
    cohort,
    assessmentID,
    alertLevelID,
    userType
  ) {
    return this.services.baseAPI.get(
      `institutions/${institutionID}/${cohort}/assessments/${assessmentID}/alert_levels/${alertLevelID}/alert_lists/${userType}`
    );
  }

  // public getInstitutionsOverallAssessmentData(institutionID, assessmentID, userType) {
  //   return this.services.baseAPI.get(`institutions/${institutionID}/assessments/${assessmentID}/generic/${userType}/overall_stats?`);
  // }
  public getInstitutionsOverallAssessmentDataFiltered(
    institutionID,
    assessmentID,
    cohort,
    userType,
    searchQuery
  ) {
    return this.services.baseAPI.get(
      `institutions/${institutionID}/${cohort}/assessments/${assessmentID}/generic/${userType}/overall_stats?${searchQuery}`
    );
  }

  public getGenericCohortsRes(institutionID, userType) {
    return this.services.baseAPI.get(
      `institutions/${institutionID}/user_cohorts_list/${userType}/`
    );
  }

  public updateCustomFields(item) {
    return this.services.baseAPI.put(`users/update_custom_fields`, item);
  }

  public uploadInstitutionURN(item, sid) {
    return this.services.baseAPI.post(
      `institutions/users/upload_urns?sid=${sid}`,
      item
    );
  }
  public uploadDepartmentCodes(item) {
    return this.services.baseAPI.post(
      `institutions/users/upload_dept_codes`,
      item
    );
  }

  public registerInstitutionGeneric(item) {
    return this.services.baseAPI.post(
      `institutions/register_general`,
      item,
      true
    );
  }

  public registerInstitutionMarketing(item) {
    return this.services.baseAPI.post(
      `institutions/register_marketing`,
      item,
      true
    );
  }

  public getInstitutionTypes() {
    return this.services.baseAPI.get(`institutions/types`, true);
  }
  public getInstitutionYearGroups(institutionID) {
    return this.services.baseAPI.get(
      `institutions/${institutionID}/year_groups`
    );
  }
  public getInstitutionDepartments(institutionID) {
    return this.services.baseAPI.get(
      `institutions/${institutionID}/departments`
    );
  }

  public generateAssessmentCohortReport(
    institutionID,
    assessmentID,
    cohort,
    sid,
    regenerate,
    yeargroup
  ) {
    if (yeargroup) {
      return this.services.plBaseAPI.get(
        `institutions/assessments/${assessmentID}/reports/alert_level_summary_report/${cohort}?sid=${sid}&regenerate=${regenerate}&yeargroup=${yeargroup}`
      );
    } else {
      return this.services.plBaseAPI.get(
        `institutions/assessments/${assessmentID}/reports/alert_level_summary_report/${cohort}?sid=${sid}&regenerate=${regenerate}`
      );
    }
  }

  public generateStudentAssessmentReport(studentId, assessmentId, sid) {
    return this.services.baseAPI.get(
      `users/${studentId}/assessments/${assessmentId}/gen_single_page_report?sid=${sid}`
    );
  }

  public updateInstitutionsContact(item) {
    return this.services.baseAPI.put(`institutions/contact/update`, item);
  }
  public makePayment(item) {
    return this.services.baseAPI.post(`institutions/make_payment`, item);
  }
  public cancelSubscription() {
    return this.services.baseAPI.post(`institutions/cancel_subscription`);
  }

  public downloadCompeletionReport(institutionId, endDate, sid) {
    return this.services.baseAPI.get(
      `admins/institutions/${institutionId}/assessments/end/${endDate}/completion_report?sid=${sid}`
    );
  }

  public signUpInstitutionPromotional(item) {
    return this.services.baseAPI.post(
      `institutions/register_promotional`,
      item,
      true
    );
  }

  public userGlobalSearch(institutionId, userType, searchQuery) {
    return this.services.baseAPI.get(
      `institutions/${institutionId}/user_global_search/${userType}/?query=${searchQuery}`
    );
  }

  public fetchAvailableUserAssessments(userId) {
    return this.services.baseAPI.get(
      `institutions/learners/${userId}/available_assessments`
    );
  }

  public assignUserAssessment(item) {
    return this.services.baseAPI.post(`institutions/learners/allocate`, item);
  }

  public downloadExecutiveSummaryReport(
    assessment,
    cohort,
    sid,
    regenerate,
    yeargroup
  ) {
    if (yeargroup) {
      return this.services.plBaseAPI.get(
        `institutions/assessments/${assessment}/reports/executive_summary/${cohort}?sid=${sid}&regenerate=${regenerate}&yeargroup=${yeargroup}`
      );
    }

    return this.services.plBaseAPI.get(
      `institutions/assessments/${assessment}/reports/executive_summary/${cohort}?sid=${sid}&regenerate=${regenerate}`
    );
  }

  public downloadTeacherReport(assessment, cohort, sid, regenerate) {
    return this.services.plBaseAPI.get(
      `institutions/assessments/${assessment}/reports/summarized_teacher_single_page/${cohort}?sid=${sid}&regenerate=${regenerate}`
    );
  }

  public downloadToLearnerReport(
    assessment,
    cohort,
    sid,
    regenerate,
    yeargroup
  ) {
    if (yeargroup) {
      return this.services.plBaseAPI.get(
        `institutions/assessments/${assessment}/reports/summarized_student_single_page/${cohort}?sid=${sid}&regenerate=${regenerate}&yeargroup=${yeargroup}`
      );
    }
    return this.services.plBaseAPI.get(
      `institutions/assessments/${assessment}/reports/summarized_student_single_page/${cohort}?sid=${sid}&regenerate=${regenerate}`
    );
  }

  public fetchQuantileTop5(assessmentId, cohort, userType) {
    return this.services.plBaseAPI.get(
      `institutions/assessments/${assessmentId}/stats/quickglance/${cohort}/quantile_top_5?user_type_id=${userType}`
    );
  }

  public getPhaseIntervention(assessmentId, cohort, userType, phase) {
    return this.services.plBaseAPI.get(
      `institutions/assessments/${assessmentId}/stats/quickglance/${cohort}/phase_intervention?user_type_id=${userType}&phase=${phase}`
    );
  }

  public getQuickGlanceAlerts(assessmentId, cohort, userType) {
    return this.services.plBaseAPI.get(
      `institutions/assessments/${assessmentId}/stats/quickglance/${cohort}/alerts_top_5?user_type_id=${userType}`
    );
  }

  public getLeastActiveLearners(startDate, endDate, yearGroup) {
    return this.services.plBaseAPI.get(
      `institutions/least_active_learners/${startDate}/${endDate}/list?yeargroup=${yearGroup}`
    );
  }
  public getInactiveLearners(startDate, endDate, yearGroup) {
    return this.services.plBaseAPI.get(
      `institutions/inactive_learners/${startDate}/${endDate}/list?yeargroup=${yearGroup}`
    );
  }

  public getMostActiveLearners(startDate, endDate, yearGroup) {
    return this.services.plBaseAPI.get(
      `institutions/most_active_learners/${startDate}/${endDate}/list?yeargroup=${yearGroup}`
    );
  }

  public downloadPerceptionsReport(assessmentId, cohort, sid) {
    return this.services.plBaseAPI.get(
      `institutions/assessments/${assessmentId}/reports/perception_summary/${cohort}?sid=${sid}`
    );
  }

  public downloadTrustedAdultReport(sid) {
    return this.services.plBaseAPI.get(
      `institutions/reports/trusted_adult_report?sid=${sid}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/API/v1/Institutions.ts